var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExperiencias(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 26",
    id: "svg28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".cls-1{fill:#004c7b;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, "Recurso 202") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title6"
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,14a5,5,0,1,1,5-5A5,5,0,0,1,11,14Zm0-8a3,3,0,1,0,3,3A3,3,0,0,0,11,6Z",
    id: "path8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "16.01 22.16 15.13 16.76 12.69 15.95 13.31 14.05 16.9 15.24 17.99 21.84 16.01 22.16",
    id: "polygon10"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "5.99 22.16 4.01 21.84 5.1 15.24 8.69 14.05 9.31 15.95 6.87 16.76 5.99 22.16",
    id: "polygon12"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 6,
    width: 4,
    height: 2,
    id: "rect14"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 10,
    width: 8,
    height: 2,
    id: "rect16"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 14,
    width: 8,
    height: 2,
    id: "rect18"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 20,
    y: 18,
    width: 8,
    height: 2,
    id: "rect20"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 11,
    y: 24,
    width: 10,
    height: 2,
    id: "rect22"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "32 26 23 26 23 24 30 24 30 2 2 2 2 24 9 24 9 26 0 26 0 0 32 0 32 26",
    id: "polygon24"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExperiencias);
export default __webpack_public_path__ + "static/media/experiencias.54e454313e5a017fc77e35c1d2a586a3.svg";
export { ForwardRef as ReactComponent };